import React, {Fragment} from 'react'
import { Link } from 'gatsby'
import Header from '../components/Header'
import Hero from '../components/Senior/Hero'
import DownloadApp from '../components/Senior/DownloadApp'
import Quiz from '../components/Senior/Quiz'
import Content from '../components/Senior/Content'
import CTA from '../components/Senior/CTA'
import Footer from '../components/Footer'
import { logPage } from '../components/Analytics'


class Senior extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            device: 'desktop',
        }
    }

    componentDidMount(){
        logPage()
    }

    render(){
        return(
            <Fragment>
                <Header logoColor="#32e2b9" classStatic="" dropDownColor="black" page='senior' title="Albert" />
                <Hero/>
                <DownloadApp />
                <Quiz />
                <Content />
                <CTA/>
                <Footer/>
            </Fragment>
        )
    }
}

export default Senior;